module.exports = __webpack_public_path__ + "img/erp-logos_0012_saphana.8658d591.jpg";